import script from "./NurseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NurseCard.vue?vue&type=script&setup=true&lang=ts"

import "./NurseCard.vue?vue&type=style&index=0&id=6d55ce92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d55ce92"]])

export default __exports__